import { findLast } from "../../../../../../Common/IterableUtils";
import { IModelPath, ModelPath, PathTokens } from "../../../../../../Common/ModelPath/ModelPath";
import { MatchKind } from "../../../../../../Common/ModelPath/PathMatcher";
import { ModelPathBuilder } from "../../../../../../Common/ModelPath/ModelPathBuilder";

export class IterationContext {
    private readonly pathToList: ModelPath;
    private readonly instance: string;

    public constructor(pathToList: ModelPath, instance: string) {
        this.pathToList = pathToList.joinWith(PathTokens.each);
        this.instance = instance;
    }

    public applyTo<R extends boolean, A extends boolean>(modelPath: IModelPath<R, A>): IModelPath<R, A> {
        const pathMatching = this.pathToList.matchFor(modelPath);
        const resultPath = new ModelPathBuilder(false);
        const lastMatchedMultiplicity = findLast(pathMatching, x => x.kind === MatchKind.MatchedMultiplicity);
        for (const match of pathMatching) {
            if (match.kind === MatchKind.MatchedPath) {
                resultPath.append(match.prefix);
            } else if (match.kind === MatchKind.MatchedMultiplicity) {
                if (match === lastMatchedMultiplicity) {
                    if (PathTokens.isMultiToken(match.target)) {
                        resultPath.append(this.instance);
                    } else {
                        resultPath.append(match.target);
                    }
                } else {
                    resultPath.append(match.target);
                }
            } else {
                if (match.source != undefined) {
                    return modelPath;
                }
                if (match.target != undefined) {
                    resultPath.append(match.target);
                }
            }
        }
        // Тут получается так, что по другому никак
        // @ts-expect-error
        return resultPath.toPath();
    }
}
